module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_53.77ae7190.mp3";